/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratUser,
    JsonStratUserFromJSON,
    JsonStratUserFromJSONTyped,
    JsonStratUserToJSON,
} from './JsonStratUser';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratUser
 */
export interface ApiResultOfJsonStratUser {
    /**
     * 
     * @type {JsonStratUser}
     * @memberof ApiResultOfJsonStratUser
     */
    data?: JsonStratUser;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratUser
     */
    result?: ApiResultOfJsonStratUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratUserFromJSON(json: any): ApiResultOfJsonStratUser {
    return ApiResultOfJsonStratUserFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratUserFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratUserToJSON(value?: ApiResultOfJsonStratUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratUserToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

